module.exports = __webpack_public_path__ + "static/images/components/BattleWizard/components/Option/images/legionaries.6d038b6f.png";


//////////////////
// WEBPACK FOOTER
// ./components/BattleWizard/components/Option/images/legionaries.png
// module id = 2520
// module chunks = 11